var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.933,
    height: 15.933,
    viewBox: "0 0 15.933 15.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONE_info",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-warning",
    transform: "translate(15.467 15.467) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.467,
    cy: 7.467,
    r: 7.467,
    transform: "translate(0.533 0.533)",
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 1.067,
    cy: 1.067,
    r: 1.067,
    transform: "translate(6.933 10.667)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.533,0V4.8",
    transform: "translate(7.467 3.733)",
    fill: "none",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.a1bab620cbda0a7341d7314635a37c2a.svg";
export { ForwardRef as ReactComponent };